/**
 * Return request action creator Object Type
 * @param {String} type
 * @param {Object} payload
 */
export function handleAction(type, payload) {
  return { type, payload };
}
